module.exports = __webpack_public_path__ + "static/media/hhcd0.be306346.wav";